import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CELEBRATION_ACHIEVEMENT_BADGE_TIMEOUT_MS } from '../constants';
import { IAchievement } from '../types';
import AchievementBadge from './AchievementBadge';
import './AchievementBadgesList.scss';

export interface IAchievementBadgesListProps {
  achievements: IAchievement[];
  show: boolean;
}

export const AchievementBadgesList: React.FC<IAchievementBadgesListProps> = ({ achievements, show }) => {
  const [visibleLength, setVisibleLength] = useState<number>(1);
  const animationTimeout = useRef<any>();
  const clearAnimationTimeout = useCallback(() => {
    clearTimeout(animationTimeout.current);
    animationTimeout.current = undefined;
  }, []);

  useEffect(() => {
    if (!show) {
      // do nothing if not shown
      return;
    }
    if (animationTimeout.current) {
      // clear previous animation timer
      clearAnimationTimeout();
    }
    if (visibleLength >= achievements.length) {
      // do nothing if rendered all badges
      return;
    }
    // set up animation
    animationTimeout.current = setTimeout(
      () => setVisibleLength(visibleLength + 1),
      CELEBRATION_ACHIEVEMENT_BADGE_TIMEOUT_MS
    );
  }, [achievements, clearAnimationTimeout, setVisibleLength, show, visibleLength]);

  if (!show) {
    return null;
  }

  const badges = achievements.map((achievement, index) => {
    if (index >= visibleLength) {
      return null;
    }
    return <AchievementBadge key={index} type={achievement.type} subType={achievement.subType} />;
  });

  const fourItemsClass = achievements.length === 4 ? ' four' : '';
  const twoColumnsClass = achievements.length > 3 ? ' columns' : '';
  const bigClass = achievements.length > 6 ? ' big' : '';
  const listClass = `achievement-badges-list${fourItemsClass}${twoColumnsClass}${bigClass}`;
  return <div className={listClass}>{badges}</div>;
};

export default AchievementBadgesList;
